import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex'
import Vuex from 'vuex';
import appConfig from '@/config'
import router from '@/router'
import {appConst,$util,$http,TabRoute,menuRouteHelper,storageHelper, arrayHelper} from '@/lib'

Vue.use(Vuex);
interface AppState {
    // cachePage: Array<any>;
    // lang: string;
    // isFullScreen: boolean;
    // openedSubmenuArr: Array<any>;
    // menuTheme: string;
    // themeColor: string,
    // pageOpenedList: Array<any>;
    // currentPageName: string;
    // currentPath: Array<any>;
    // menuList: Array<any>;
    // routers: Array<any>;
    // tagsList: Array<any>;
    // messageCount: number;
    // dontCache: Array<any>;
    // noticeList: Array<any>;

    breadCrumbList: Array<any>;
    tagNavList:Array<TabRoute>;
    homeRoute:any;
    local:any;
    menuTheme: string;
    themeColor: string;
    localization:any;
    systemCode:Array<any>;
    tenancyName: string;
}

const closePage=(state:AppState, menuRoute:any)=>{
    const nextRoute = menuRouteHelper.getNextRoute(state.tagNavList, menuRoute)
    state.tagNavList = state.tagNavList.filter(item => {
      return !menuRouteHelper.routeEqual(item.menuRoute, menuRoute)
    })
    router.push(nextRoute)
};

class AppModule implements Module<AppState, any>{
    namespaced = true;
    state = {
        breadCrumbList: [],
        homeRoute: {},
        tagNavList: [],
        local:storageHelper.localRead('local'),
        menuTheme: 'dark',
        themeColor: '',
        localization: {},
        systemCode:[],
        tenancyName:""

    };
    mutations = {
        setBreadCrumb (state:AppState, route:any) {
            state.breadCrumbList = menuRouteHelper.getBreadCrumbList(route, state.homeRoute)
        },
        setHomeRoute (state:AppState, routes:Array<any>) {
            state.homeRoute = menuRouteHelper.getHomeRoute(routes, appConfig.homeName)
        },
        setTagNavList (state:AppState, list:Array<TabRoute>) {
            let tagList = [];
            if (list) {
              tagList = [...list];
            } else {
                tagList = menuRouteHelper.getTagNavListFromLocalstorage() || [];
            }
            if (tagList[0] && tagList[0].name !== appConfig.homeName) {
                tagList.shift();
            }
            let homeTagIndex = tagList.findIndex(item => item.name === appConfig.homeName)
            if (homeTagIndex > 0) {
              let homeTag = tagList.splice(homeTagIndex, 1)[0]
              tagList.unshift(homeTag)
            }
            state.tagNavList = tagList
            menuRouteHelper.setTagNavListInLocalstorage([...tagList])
        },
       
        closeTag (state:AppState, menuRoute:any) {
            let tag = state.tagNavList.filter(item => menuRouteHelper.routeEqual(item.menuRoute, menuRoute))
            menuRoute = tag[0] ? tag[0] : null
            if (!menuRoute) return
            closePage(state, menuRoute.menuRoute)
        },

        // addTag (state:AppState, { route, type = 'unshift' }) {
        //     let router = menuRouteHelper.getRouteTitleHandled(route.menuRoute)

        //     let newTagIndex = state.tagNavList.findIndex(item => menuRouteHelper.routeEqual(item.menuRoute?item.menuRoute:item, route.menuRoute))
        //     if(newTagIndex>=0){
        //         state.tagNavList.splice(newTagIndex,1,route);
        //     } else {
        //         if (type === 'push') state.tagNavList.push(route)
        //         else {
        //         if (router.name === appConfig.homeName) state.tagNavList.unshift(route)
        //         else state.tagNavList.splice(1, 0, route)
        //         }
        //         menuRouteHelper.setTagNavListInLocalstorage([...state.tagNavList])
        //     }
        // },

        addNewTag(state:AppState, { route, type = 'unshift' }){
            let newTabRoute = menuRouteHelper.createNewTabRoute(route);
            let existTagRouteIndex = state.tagNavList.findIndex(item => item.name == newTabRoute.name);
            //若已存在，则更新当前路由以及历史路由信息。
            if(existTagRouteIndex>=0){
                state.tagNavList[existTagRouteIndex].currentRoute = newTabRoute.currentRoute;
                state.tagNavList[existTagRouteIndex].history = menuRouteHelper.getHistory(state.tagNavList[existTagRouteIndex],route);
            } else {
                if (type === 'push' && route.name !== appConfig.homeName ) {
                    state.tagNavList.push(newTabRoute)
                }
                else {
                    //若为首页，则需添加到第一个
                    if (route.name === appConfig.homeName) state.tagNavList.unshift(newTabRoute)
                    else state.tagNavList.splice(1, 0, newTabRoute)
                }
            }
            //持久化
            menuRouteHelper.setTagNavListInLocalstorage([...state.tagNavList])
        },

        setLocal (state:AppState, lang) {
            storageHelper.localSave('local', lang)
            state.local = lang
        },
        logout(state: AppState) {
            localStorage.clear();
            sessionStorage.clear();
        },

       
        changeMenuTheme(state: AppState, theme: string) {
            state.menuTheme = theme;
        },
        changeMainTheme(state: AppState, mainTheme: string) {
            state.themeColor = mainTheme;
        },

        setSystemCode(state:AppState, systemCode:any){
            state.systemCode = systemCode;
        },

        setTenancyName(state:AppState, tenancyName:string){
            state.tenancyName = tenancyName;
        }
    }
    actions = {
        async login(content: ActionContext<AppState, any>, payload: any) {
            let rep = await $http.post("Authenticate/Authenticate", payload.data);
            let tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) : undefined;
            $util.basic.utils.setToken(rep.data.result.accessToken, tokenExpireDate);
            $util.basic.utils.setCookieValue(appConst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, "/")
        },
    }
}
const App = new AppModule();
export default App;